import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tab,
  Tabs,
  Tooltip,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { Add } from "@material-ui/icons";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import Modal from "../../components/Control/Modal";
import useConfirm from "../../components/Control/useConfirm";
import { Wrapper } from "../../components/Control/Flexbox";
import { usePermission } from "../../components/usePermission";
import AddEditCategory from "./AddEditCategory";
import AddEditSpecialProcess from "./AddEditSpecialProcess";
import "../style.css";

const SpecialProcessTabs = () => {
  const history = useHistory();
  const permissions = usePermission(6);
  const [categories, setCategories] = useState([]);
  const [processes, setProcesses] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [render, setRender] = useState(false);

  const [isCategoryModal, setIsCategoryModal] = useState(false);
  const [categoryId, setCategoryId] = useState(null);
  const [isProcessModal, setIsProcessModal] = useState(false);

  const [DialogDeleteCategory, confirmDeleteCategory] = useConfirm(
    "DELETE CATEGORY",
    "All the processes and their revisions of this category will be deleted. Are you sure you want to delete this category?",
  );
  const [DialogDeleteProcess, confirmDeleteProcess] = useConfirm(
    "DELETE PROCESS",
    "All the revisions of this process will be deleted. Are you sure you want to delete this process?",
  );

  const activeCategory = categories[tabValue];

  useEffect(() => {
    if (isCategoryModal) return;
    axios
      .get("/api/specialProcess/categories")
      .then((res) => {
        setCategories(res.data);
        setTabValue((prev) => (prev < res.data.length ? prev : 0));
      })
      .catch((err) => console.log(err));
  }, [render, isCategoryModal]);

  useEffect(() => {
    if (isProcessModal) return;
    if (!activeCategory?._id) {
      setProcesses([]);
      return;
    }
    axios
      .get(`/api/specialProcess/processes/${activeCategory._id}`)
      .then((res) => setProcesses(res.data))
      .catch((err) => console.log(err));
  }, [activeCategory?._id, render, isProcessModal]);

  const deleteCategory = async (id) => {
    const ans = await confirmDeleteCategory();
    if (!ans) return;
    axios
      .delete(`/api/specialProcess/category/${id}`)
      .then(() => {
        alert("Category deleted successfully");
        setTabValue(0);
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  const deleteProcess = async (id) => {
    const ans = await confirmDeleteProcess();
    if (!ans) return;
    axios
      .delete(`/api/specialProcess/process/${id}`)
      .then(() => {
        alert("Special process deleted successfully");
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <main style={{ paddingBottom: "4rem" }}>
        <div className="divflex" style={{ fontSize: "24px" }}>
          SPECIAL PROCESSES
          {permissions?.includes("edit") && (
            <div>
              <Button
                type="button"
                variant="contained"
                color="primary"
                size="large"
                onClick={() => {
                  setCategoryId(null);
                  setIsCategoryModal(true);
                }}
                style={{
                  background: "#064a29",
                  color: "#fafafa",
                  marginRight: "1rem",
                }}
                startIcon={<Add />}
              >
                New Category
              </Button>
            </div>
          )}
        </div>

        <Paper elevation={2} style={{ margin: "1rem 1.4rem" }}>
          <Tabs
            value={categories.length ? tabValue : 0}
            onChange={(_, value) => setTabValue(+value)}
            aria-label="special process category tabs"
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            {categories.length ? (
              categories.map((category) => (
                <Tab key={category._id} label={category.category_name} />
              ))
            ) : (
              <Tab label="NO CATEGORY" disabled />
            )}
          </Tabs>
        </Paper>

        {activeCategory ? (
          <>
            <Wrapper
              justify="space-between"
              style={{
                margin: "0 1.4rem",
                borderBottom: "1px solid #c80202",
                alignItems: "center",
              }}
            >
              <p className="card-btn-para" style={{ color: "#c80202" }}>
                • CATEGORY{" "}
                <span
                  style={{
                    fontWeight: 400,
                    color: "black",
                    textTransform: "uppercase",
                  }}
                >
                  {activeCategory.category_name}
                </span>
              </p>
              <Wrapper style={{ gap: "0.5rem", alignItems: "center" }}>
                {permissions?.includes("edit") && (
                  <>
                    <Button
                      variant="outlined"
                      color="primary"
                      startIcon={<BorderColorIcon />}
                      onClick={() => {
                        setCategoryId(activeCategory._id);
                        setIsCategoryModal(true);
                      }}
                    >
                      Edit Category
                    </Button>
                    <Button
                      type="button"
                      variant="contained"
                      size="large"
                      style={{ background: "#003566", color: "#fafafa" }}
                      startIcon={<Add />}
                      onClick={() => setIsProcessModal(true)}
                    >
                      Add Process
                    </Button>
                  </>
                )}
                {permissions?.includes("delete") && (
                  <Button
                    variant="outlined"
                    style={{ color: "#c80202", borderColor: "#c80202" }}
                    startIcon={<DeleteIcon />}
                    onClick={() => deleteCategory(activeCategory._id)}
                  >
                    Delete Category
                  </Button>
                )}
              </Wrapper>
            </Wrapper>

            <TableContainer
              component={Paper}
              style={{ margin: "1rem 1.4rem", width: "auto" }}
            >
              <Table size="small">
                <TableHead>
                  <TableRow style={{ padding: "6px" }}>
                    <TableCell style={{ fontWeight: "bold" }} align="center">
                      S.No.
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }} align="center">
                      Process Number
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }} align="center">
                      Process Name
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }} align="center">
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {processes.map((item, index) => (
                    <TableRow key={item._id}>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center">{item.process_no}</TableCell>
                      <TableCell align="center">{item.process_name}</TableCell>
                      <TableCell align="center" style={{ width: "180px" }}>
                        {permissions?.includes("edit") && (
                          <Tooltip title="Edit - ECN Revisions" arrow>
                            <IconButton
                              size="small"
                              style={{ marginRight: "0.5rem" }}
                              onClick={() =>
                                history.push(
                                  `/specialProcess/revisions/${item._id}`,
                                )
                              }
                            >
                              <EditIcon
                                style={{
                                  fontSize: "1.4rem",
                                  color: "#161a1d",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        )}
                        {permissions?.includes("delete") && (
                          <Tooltip title="Delete Process" arrow>
                            <IconButton
                              size="small"
                              onClick={() => deleteProcess(item._id)}
                            >
                              <DeleteIcon
                                style={{ fontSize: "1.4rem", color: "#c80202" }}
                              />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        ) : (
          <p style={{ margin: "1.4rem", fontSize: "1rem" }}>
            No category found. Create a category to start adding special
            processes.
          </p>
        )}

        <Modal
          title={categoryId ? "update category" : "create new category"}
          openPopup={isCategoryModal}
          closeModal={() => {
            setIsCategoryModal(false);
            setCategoryId(null);
          }}
          backgroundColor="white"
        >
          <AddEditCategory id={categoryId} {...{ setIsCategoryModal }} />
        </Modal>

        <Modal
          title="add special process"
          openPopup={isProcessModal}
          closeModal={() => setIsProcessModal(false)}
          backgroundColor="white"
        >
          <AddEditSpecialProcess
            categoryId={activeCategory?._id}
            {...{ setIsProcessModal }}
          />
        </Modal>
      </main>
      <DialogDeleteCategory />
      <DialogDeleteProcess />
    </>
  );
};

export default SpecialProcessTabs;
